import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCheckCircle,
  faCopy,
  faBan,
  faTimesCircle,
  faLock,
  faLockOpen,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckCircle, faCopy, faBan, faTimesCircle, faLock, faLockOpen)

Vue.component('fa-icon', FontAwesomeIcon)
